import { render, staticRenderFns } from "./PracticeDone.vue?vue&type=template&id=15d09483"
import script from "./PracticeDone.vue?vue&type=script&lang=js"
export * from "./PracticeDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports